const module = { name: 'Fandango/overlay', exports: {} }; const exports = module.exports;



const Selectors = {
    GLOBAL_SEARCH_ICON: '.js-global-search-icon'
}


const Styles = {
    CANCEL_ICON: 'fd-overlay__close-btn-x',
    OVERLAY: 'fd-overlay',
    CONTENT: 'fd-overlay__container',
    OPEN: 'fd-overlay--open',
}


const DataAttribs = {
    FOCUSABLE: 'focusabletake22924',
    ID: 'overlayId',
    MICROMODAL_CLOSE: 'micromodalClose',
    REMOVE_ON_CLOSE: 'remove'
}


const EventNames = Object.freeze({
    CLOSED: 'fd.overlay.close',
})


const FOCUS_TIMEOUT = 100


const DOM_UPDATE_DELAY = 100
function closeOverlay(overlay, opts) {
    if (!overlay) {
        return;
    }
    let id;
    if (typeof overlay === 'string') {
        id = overlay;
        overlay = document.getElementById(id);
    }
    else {
        id = overlay.id;
    }
    if (!id || !overlay) {
        return;
    }
    window.MicroModal.close(id);
    opts = opts || {};
    if (!opts.silent) {
        overlay.dispatchEvent(new Event(EventNames.CLOSED));
    }
    if (opts.isKeyPress) {
        const searchIcon = document.querySelector(Selectors.GLOBAL_SEARCH_ICON);
        if (searchIcon) {
            setTimeout(() => searchIcon.focus(), FOCUS_TIMEOUT);
        }
    }
    const removeOnClose = overlay.dataset[DataAttribs.REMOVE_ON_CLOSE] === 'true';
    if (removeOnClose) {
        overlay.remove();
    }
}
function newOverlayElement(id, opts) {
    const aside = document.createElement('aside');
    aside.id = id;
    aside.setAttribute('role', 'dialog');
    aside.classList.add(Styles.OVERLAY);
    if (opts.overlayStyle) {
        aside.classList.add(opts.overlayStyle);
    }
    if (!opts.disableCloseOnModalClick) {
        aside.dataset[DataAttribs.MICROMODAL_CLOSE] = 'true';
    }
    aside.dataset[DataAttribs.REMOVE_ON_CLOSE] = Boolean(opts.removeOnClose === undefined || opts.removeOnClose === true);
    return aside;
}
function newContainerElement(content, opts) {
    const div = document.createElement('div');
    div.classList.add(Styles.CONTENT);
    if (opts.containerStyle) {
        if (Array.isArray(opts.containerStyle)) {
            opts.containerStyle.forEach(style => div.classList.add(style));
        }
        else {
            div.classList.add(opts.containerStyle);
        }
    }
    if (typeof content === 'string') {
        div.innerHTML = content;
    }
    else {
        div.appendChild(content);
    }
    return div;
}
function newCloseBtnElement(overlayId, opts) {
    const btn = document.createElement('button');
    btn.classList.add(Styles.CANCEL_ICON);
    if (opts.closeBtnStyle) {
        if (Array.isArray(opts.closeBtnStyle)) {
            opts.closeBtnStyle.forEach(style => btn.classList.add(style));
        }
        else {
            btn.classList.add(opts.closeBtnStyle);
        }
    }
    btn.dataset[DataAttribs.ID] = overlayId;
    btn.dataset[DataAttribs.FOCUSABLE] = true;
    btn.innerHTML = opts.closeBtnText || 'Cancel';
    btn.tabIndex = opts.closeBtnTabIndex || '2';
    btn.addEventListener('click', e => closeOverlay(e.target.dataset[DataAttribs.ID]));
    return btn;
}
function makeOverlay(id, content, opts) {
    const overlay = newOverlayElement(id, opts);
    const container = newContainerElement(content, opts);
    overlay.appendChild(container);
    const closeBtn = newCloseBtnElement(id, opts);
    if (opts.closeBtnParent) {
        const parent = container.querySelector(opts.closeBtnParent);
        if (opts.closeBtnFirst) {
            parent.insertBefore(closeBtn, parent.firstChild);
        }
        else {
            parent.appendChild(closeBtn);
        }
    }
    else {
        container.appendChild(closeBtn);
    }
    return overlay;
}
function attach(content, opts) {
    opts = opts || {};
    const id = 'fd-overlay$' + Date.now();
    const overlay = makeOverlay(id, content, opts);
    document.body.appendChild(overlay);
    function closeHandler() {
        closeOverlay(overlay, {
            silent: true
        });
    }
    function show() {
        const microModalOpts = {
            awaitCloseAnimation: false,
            debugMode: true,
            disableScroll: true,
            openClass: Styles.OPEN,
        };
        if (opts.microModalOpts) {
            Object.assign(microModalOpts, opts.microModalOpts);
        }
        window.MicroModal.show(id, microModalOpts);
    }
    function openHandler() {
        if (opts.noTimeout) {
            show();
        }
        else {
            setTimeout(show, DOM_UPDATE_DELAY);
        }
    }
    overlay.close = closeHandler;
    overlay.open = openHandler;
    return overlay;
}
function open(content, opts) {
    const overlay = attach(content, opts);
    overlay.open();
    return overlay;
}
function close(overlay) {
    closeOverlay(overlay, {
        silent: true
    });
}
function extendLegacy(area, publicInterface) {
    window.Fandango = window.Fandango || {};
    const { Fandango } = window;
    if (!Fandango[area]) {
        Fandango[area] = publicInterface;
    }
}
module.exports = {
    EventNames,
    attach,
    close,
    open,
};
extendLegacy('overlay', module.exports);
export default module.exports;